import { acceptHMRUpdate, defineStore } from "pinia";
import { ref } from "vue";
import { createVisitTypeApi } from "#/decision_tree_viewer/api/visit-type";

const api = createVisitTypeApi();

export const useVisitTypeStore = defineStore("visit-type", () => {
  const visitTypes = ref(null);

  async function load() {
    visitTypes.value = await api.all();
  }

  return {
    // visitTypes
    visitTypes,

    // actions
    load,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useVisitTypeStore, import.meta.hot));
}
